import { makeStyles } from '@material-ui/core'
import { fontSize } from 'helpers/reports/constants'

const styles = makeStyles((theme) => ({
  root: {
    width: '100vw',
    justifyContent: 'center',
    height: '100%',
    flexDirection: 'column',
    paddingBottom: 80,
    [theme.breakpoints.down('md')]: {
      paddingBottom: 0,
    },
  },
  link: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
      color: theme.palette.primary.dark,
    },
  },
  price: {
    fontSize: 32,
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
  subtitle: {
    fontSize: 16,
    fontWeight: 400,
  },
}))

export default styles
